import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2, Check, AlertCircle } from "lucide-react";
import { API, BRAND } from "../config";

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;
    
    const verifyEmail = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Token di verifica mancante');
        return;
      }
      
      try {
        const response = await axios.get(`${API}/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage(response.data.message);
        setTimeout(() => { navigate('/login', { replace: true }); }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Errore durante la verifica');
      }
    };
    
    verifyEmail();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex flex-col items-center justify-center p-4" data-testid="verify-email-page">
      <div className="w-full max-w-sm text-center">
        <img src={BRAND.logo} alt={BRAND.name} className="w-20 h-20 mx-auto mb-6 rounded-2xl object-contain shadow-[0_0_30px_rgba(245,166,35,0.2)]" />
        
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-[#F5A623] animate-spin mx-auto mb-4" />
            <p className="text-white text-lg font-bold">Verifica in corso...</p>
          </>
        )}
        
        {status === 'success' && (
          <div className="glass rounded-3xl p-8">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-500/20 flex items-center justify-center">
              <Check className="w-8 h-8 text-green-400" />
            </div>
            <h2 className="text-2xl font-black text-white mb-2" style={{fontFamily: 'Barlow Condensed'}}>
              Email Verificata!
            </h2>
            <p className="text-gray-400 mb-4">{message}</p>
            <p className="text-sm text-gray-500">Verrai reindirizzato al login...</p>
          </div>
        )}
        
        {status === 'error' && (
          <div className="glass rounded-3xl p-8">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
              <AlertCircle className="w-8 h-8 text-red-400" />
            </div>
            <h2 className="text-2xl font-black text-white mb-2" style={{fontFamily: 'Barlow Condensed'}}>
              Errore di Verifica
            </h2>
            <p className="text-gray-400 mb-6">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="w-full h-12 btn-primary rounded-xl text-sm"
            >
              Torna al Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
